import React, { useState, useRef, useEffect } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Row,
  Col,
  Form,
  FormGroup,
  FormInput,
} from "shards-react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ToastContainer, toast } from "react-toastify";
import {
  faFileLines,
  faCircleXmark,
} from "@fortawesome/free-regular-svg-icons";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";

const axios = require("axios").default;
const StyledUpload = styled.div`
  min-width: 162px;
  max-width: 162px;
  min-height: 154px;
  max-height: 154px;
  font-family: 'Sarabun',"Montserrat";
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding: 20px 15px;
  border: 1px dashed #cecece;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  display: flex;
  align-items: center;
  p {
    letter-spacing: 0.1em;
    text-transform: uppercase;
    opacity: 1;
    transition: opacity 0.25s ease-in-out;
  }

  &.is-highlight {
    background-color: rgba(#4aa0ea, 0.5);

    p {
      opacity: 1;
    }
  }

  &.is-drop {
    p {
      opacity: 0;
    }
  }
`;
const StyledMedia = styled.div`
  color: #000;
  justify-content: center;
  .media-icon {
    svg {
      height: 60px;
    }
  }
  .media-body-title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .media-body-subtitle {
    color: #818181;
  }
  .media-body {
    flex: none;
  }
`;

const StyledLoadding = styled.div`
  width: 162px;
  height: 162px;
`;
const StyledPreview = styled.div`
  width: 162px;
  height: 162px;
  position: relative;
  overflow: hidden;
  background-position: center center;
  background-repeat: no-repeat;
  border-radius: 6px;
  border: 1px solid #dddddd;
`;
const StyledImagePreview = styled.img`
  position: absolute;
  top: -100%;
  left: 0;
  right: 0;
  bottom: -100%;
  margin: auto;
  width: 100%;
  max-width: 100%;
  display: block;
`;
const ModalClose = styled.a`
  color: black;
  cursor: pointer;
  position: absolute;
  right: 20px;
  :hover {
    color: black;
  }
`;

const ContentImage = styled.div`
  border-bottom: 1px solid #e8e8e8;
  width: 162px;
  height: 162px;
`;

const ContentChangeImage = styled.div`
  text-align: center;
`;
const TitleImage = styled.a``;

const ButtonChangeImage = styled.a`
  color: #000;
  text-decoration: revert;
`;
const StyledModalFooter = styled(ModalFooter)`
  display: block;
`;

const ModalCreateContentMain = (props) => {
  const { token } = useToken();
  const { open, toggle, data, openDelete } = props;
  const [onloading, setOnloading] = useState(false);
  const [fileUpload, setFileUpload] = useState(null);
  const [fileInput, setFileInput] = useState(null);
  const [filePath, setFilePath] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [contentSettingId, setContentSettingId] = useState(null);
  const [contentSettingName, setContentSettingName] = useState(null);
  const [contentSettingNameEN, setContentSettingNameEN] = useState(null);

  const showNotify = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "error":
        toast.error(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "warn":
        toast.warn(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      case "info":
        toast.info(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        break;
      default:
        toast.success(message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
    }
  };

  const handleEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleUpload = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const [file] = e.target.files || e.dataTransfer.files;
    setSelectedFile(file);
  };

  const uploadFile = (file) => {
    var data = new FormData();
    data.append("file", file);
    var config = {
      method: "post",
      url: `${baseUrl}/v1/upload`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(config)
      .then(function(response) {
        setFileUpload(response.data);
        setFilePath(response.data.path);
        setFileName(splitPath(response.data.originalname));
        setOnloading(false);
      })
      .catch(function(error) {
        console.log("/upload error", error);
        setOnloading(false);
      });
  };
  const handleClick = (event) => {
    fileInput.click();
  };
  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  useEffect(() => {
    if (selectedFile != null) {
      setFileUpload(null);
      setOnloading(true);
      uploadFile(selectedFile);
    }
  }, [selectedFile]);

  const splitPath = (path) => {
    if (path.includes("\\")) {
      var s = path.split("\\");
      return s[1];
    } else {
      return path;
    }
  };
  const onSaveContentMain = () => {
    const sendObject = {
      contentSettingName: contentSettingName,
      contentSettingNameEN: contentSettingNameEN,
      contentSettingPic: fileUpload.path,
    };
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/createcontent`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: sendObject,
    };

    axios(config)
      .then((response) => {
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
        toggle();
      })
      .catch((error) => {
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
      });
  };

  const onUpdateContentMain = () => {
    const sendObject = {
      params: {
        contentSettingId: contentSettingId,
      },
      update: {
        contentSettingName: contentSettingName,
        contentSettingNameEN: contentSettingNameEN,
        contentSettingPic: filePath,
      },
    };
    var config = {
      method: "post",
      url: `${baseUrl}/v1/setting/updatecontent`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: sendObject,
    };

    axios(config)
      .then((response) => {
        showNotify("แจ้งเตือน! บันทึกข้อมูลเรียบร้อย");
        toggle();
      })
      .catch((error) => {
        console.log(error);
        if(error.response.data.message){
          showNotify(error.response.data.message, "error");
        }else{
          showNotify(error.message, "error");
        }
      });
  };

  useEffect(() => {
    if (data) {
      setFilePath(data.contentSettingPic);
      setFileName(splitPath(data.contentSettingPic));
      setContentSettingId(data.contentSettingId);
      setContentSettingName(data.contentSettingName);
      setContentSettingNameEN(data.contentSettingNameEN);
    } else {
      setFilePath(null);
      setFileName(null);
      setContentSettingId(null);
      setContentSettingName(null);
      setContentSettingNameEN(null);
    }
  }, [data]);
  return (
    <>
      <Modal size="lg" open={open} toggle={toggle}>
        <ModalHeader tag="h6" titleClass="bold" style={{ border: "none" }}>
          {data ? "แก้ไขหัวข้อใหญ่" : "เพิ่มหัวข้อใหญ่"}
          <ModalClose onClick={toggle}>
            <FontAwesomeIcon icon={faCircleXmark} />
          </ModalClose>
        </ModalHeader>
        <ModalBody>
          <Form className="my-form">
            <FormGroup className="mt-2">
              <label>ชื่อหัวข้อใหญ่ (ภาษาไทย)</label>
              <FormInput
                name="contentSettingName"
                placeholder="ระบุชื่อหัวข้อใหญ่"
                value={contentSettingName ? contentSettingName : ""}
                onChange={(e) => setContentSettingName(e.target.value)}
              />
            </FormGroup>
            <FormGroup className="mt-2">
              <label>ชื่อหัวข้อใหญ่ (English)</label>
              <FormInput
                name="contentSettingNameEN"
                placeholder="ระบุชื่อหัวข้อใหญ่"
                value={contentSettingNameEN ? contentSettingNameEN : ""}
                onChange={(e) => setContentSettingNameEN(e.target.value)}
              />
            </FormGroup>

            <div className="mb-2">รูปภาพ</div>
            <small style={{marginBottom : 20, display: 'block'}}>ขนาดรูปภาพที่แนะนำคือ 238 × 279 px โดยต้องเป็น .jpg, .jpeg, .png เท่านั้น</small>           
            {filePath ? (
              <>
                {onloading ? (
                  <div>Loadding...</div>
                ) : (
                  <>
                    <ContentImage>
                      <StyledPreview>
                        <a href={`${baseUrl}/${filePath}`} target="_blank">
                          <StyledImagePreview src={`${baseUrl}/${filePath}`} />
                        </a>
                      </StyledPreview>

                      <ContentChangeImage>
                        <ButtonChangeImage
                          href="javascrript:;"
                          className="btn-link color-black"
                          onClick={(e) => handleClick(e)}
                        >
                          เปลี่ยนรูป
                        </ButtonChangeImage>
                      </ContentChangeImage>
                      <div className="upload-button">
                        <input
                          type="file"
                          className="upload-file"
                          accept="image/*"
                          ref={(fileInput) => setFileInput(fileInput)}
                          style={{ display: "none" }}
                          // onChange={handleChange}
                          onChange={(e) => changeHandler(e)}
                        />
                      </div>
                    </ContentImage>
                  </>
                )}
              </>
            ) : onloading ? (
              <StyledLoadding>Loadding...</StyledLoadding>
            ) : (
              <StyledUpload
                onDragEnter={(e) => handleEnter(e)}
                onDragLeave={(e) => handleLeave(e)}
                onDragOver={(e) => handleOver(e)}
                onDrop={(e) => handleUpload(e)}
              >
                <StyledMedia onClick={handleClick}>
                  <div className="media-icon">
                    <FontAwesomeIcon icon={faFileLines} />
                  </div>

                  <div>
                    <div>Click or drag file to this area to upload</div>
                  </div>
                </StyledMedia>
                <div className="upload-button">
                  <input
                    type="file"
                    className="upload-file"
                    accept="image/*"
                    ref={(fileInput) => setFileInput(fileInput)}
                    style={{ display: "none" }}
                    // onChange={handleChange}
                    onChange={(e) => changeHandler(e)}
                  />
                </div>
              </StyledUpload>
            )}
          </Form>
        </ModalBody>
        <StyledModalFooter>
          {data ? (
            <>
              <Button
                className="btn-outline-danger"
                style={{ width: "150px" }}
                onClick={() => {
                  openDelete();
                  toggle();
                }}
              >
                ลบหัวข้อนี้
              </Button>

              <Button
                className="btn-success pull-right"
                onClick={onUpdateContentMain}
                style={{ width: "150px" }}
                disabled={
                  !filePath || !contentSettingName || !contentSettingNameEN
                }
              >
                บันทึกข้อมูล
              </Button>
            </>
          ) : (
            <Button
              className="btn-success pull-right"
              onClick={onSaveContentMain}
              style={{ width: "150px" }}
              disabled={
                !filePath || !contentSettingName || !contentSettingNameEN
              }
            >
              บันทึกข้อมูล
            </Button>
          )}
        </StyledModalFooter>
      </Modal>
    </>
  );
};

export default ModalCreateContentMain;
